var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0455 0H19.9545C8.93392 0 0 8.93391 0 19.9545V20.0455C0 31.0661 8.93392 40 19.9545 40H20.0455C31.0661 40 40 31.0661 40 20.0455V19.9545C40 8.93391 31.0661 0 20.0455 0Z",
    fill: "url(#paint0_linear_7229_30046)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1877 8.13779H13.8105C10.3911 8.13779 7.60938 10.9196 7.60938 14.339V25.6622C7.60938 29.0816 10.3911 31.8634 13.8105 31.8634H26.1877C29.6071 31.8634 32.3888 29.0816 32.3888 25.6622V14.339C32.3888 10.9196 29.6071 8.13779 26.1877 8.13779ZM9.79695 14.339C9.79695 12.1262 11.5977 10.3254 13.8105 10.3254H26.1877C28.4005 10.3254 30.2013 12.1262 30.2013 14.339V25.6622C30.2013 27.875 28.4005 29.6758 26.1877 29.6758H13.8105C11.5977 29.6758 9.79695 27.875 9.79695 25.6622V14.339Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0025 25.7672C23.1823 25.7672 25.7707 23.1803 25.7707 19.9991C25.7707 16.8179 23.1837 14.231 20.0025 14.231C16.8214 14.231 14.2344 16.8179 14.2344 19.9991C14.2344 23.1803 16.8214 25.7672 20.0025 25.7672ZM20.0025 16.4199C21.9771 16.4199 23.5831 18.0259 23.5831 20.0005C23.5831 21.9751 21.9771 23.5811 20.0025 23.5811C18.028 23.5811 16.422 21.9751 16.422 20.0005C16.422 18.0259 18.028 16.4199 20.0025 16.4199Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3041 15.1628C27.1604 15.1628 27.8583 14.4663 27.8583 13.6087C27.8583 12.751 27.1618 12.0545 26.3041 12.0545C25.4465 12.0545 24.75 12.751 24.75 13.6087C24.75 14.4663 25.4465 15.1628 26.3041 15.1628Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7229_30046",
    x1: 5.84381,
    y1: 34.1562,
    x2: 34.1562,
    y2: 5.84522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#DD2A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#9537B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515BD4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.84d25a123f21028fa83e04eecc962fb2.svg";
export { ForwardRef as ReactComponent };